import {FC} from 'react';
//mui
import {Box} from '@mui/material';
//formik
import {Field, useFormikContext} from 'formik';
//components
import Button from '@/shared/components/Button';
import Input from '@/shared/components/Inputs/Input';
import MultipleSelect from '@/shared/components/MultipleSelect';
//constants
import {
	CANCEL,
	FIELD,
	FIELD_LABEL,
	NONE,
	OUTLINE,
	PLACEHOLDER,
	PRIMARY,
	SAVE_CHANGES,
	mealsSelectOptions,
} from '@/utils/constants';
//types
import {IOrganizationContact} from '@/utils/types';
//styles
import {formContentStyle} from './FormContent.styles';

interface FormContentProps {
	onModalClose: () => void;
}

const FormContent: FC<FormContentProps> = ({onModalClose}) => {
	const {
		submitForm,
		values: {firstName, lastName, address, city, email, state, phoneNumber, zip, meals},
	} = useFormikContext<IOrganizationContact>();

	return (
		<Box sx={formContentStyle.wrapper}>
			<Box sx={formContentStyle.content}>
				<Box sx={formContentStyle.item}>
					<Field
						id={FIELD.firstName}
						name={FIELD.firstName}
						value={firstName}
						placeholder={PLACEHOLDER.firstName}
						label={FIELD_LABEL.firstName}
						component={Input}
						parentClassName={formContentStyle.itemField}
					/>
					<Field
						id={FIELD.address}
						name={FIELD.address}
						value={address}
						placeholder={PLACEHOLDER.address}
						label={FIELD_LABEL.address}
						component={Input}
						parentClassName={formContentStyle.itemField}
					/>
				</Box>
				<Box sx={formContentStyle.item}>
					<Field
						id={FIELD.lastName}
						name={FIELD.lastName}
						value={lastName}
						placeholder={PLACEHOLDER.lastName}
						label={FIELD_LABEL.lastName}
						component={Input}
						parentClassName={formContentStyle.itemField}
					/>
					<Field
						id={FIELD.city}
						name={FIELD.city}
						value={city}
						placeholder={PLACEHOLDER.city}
						label={FIELD_LABEL.city}
						component={Input}
						parentClassName={formContentStyle.itemField}
					/>
				</Box>
				<Box sx={formContentStyle.item}>
					<Field
						id={FIELD.email}
						name={FIELD.email}
						value={email}
						placeholder={PLACEHOLDER.email}
						label={FIELD_LABEL.email}
						component={Input}
						parentClassName={formContentStyle.itemField}
					/>
					<Field
						id={FIELD.state}
						name={FIELD.state}
						value={state}
						placeholder={PLACEHOLDER.state}
						label={FIELD_LABEL.state}
						component={Input}
						parentClassName={formContentStyle.itemField}
					/>
				</Box>
				<Box sx={formContentStyle.item}>
					<Field
						id={FIELD.phoneNumber}
						name={FIELD.phoneNumber}
						value={phoneNumber}
						placeholder={PLACEHOLDER.phoneNumberZero}
						label={FIELD_LABEL.phone}
						component={Input}
						parentClassName={formContentStyle.itemField}
					/>
					<Field
						id={FIELD.zip}
						name={FIELD.zip}
						value={zip}
						placeholder={PLACEHOLDER.zip}
						label={FIELD_LABEL.zip}
						component={Input}
						parentClassName={formContentStyle.itemField}
					/>
				</Box>
			</Box>

			<Field
				id={FIELD.meals}
				name={FIELD.meals}
				value={meals}
				defaultValue={NONE}
				label={FIELD_LABEL.meal}
				component={MultipleSelect}
				options={mealsSelectOptions}
			/>

			<Box sx={formContentStyle.buttons}>
				<Button
					title={CANCEL}
					onClick={onModalClose}
					sx={formContentStyle.button}
					variant={OUTLINE}
					color={PRIMARY}
					disableRipple
				/>

				<Button title={SAVE_CHANGES} onClick={submitForm} sx={formContentStyle.button} disableRipple />
			</Box>
		</Box>
	);
};

export default FormContent;
